module.exports = __webpack_public_path__ + "img/partnerJisuSer.149a3b82.png";